"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var StatusType;

(function (StatusType) {
  StatusType["INACTIVE"] = "lsg--icon__disabled";
  StatusType["ACTIVE"] = "lsg--icon__success";
  StatusType["PENDING"] = "lsg--icon__note";
  StatusType["DECLINED"] = "lsg--icon__error";
})(StatusType = exports.StatusType || (exports.StatusType = {}));

var StatusIcon =
/** @class */
function (_super) {
  __extends(StatusIcon, _super);

  function StatusIcon() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  StatusIcon.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        status = _a.status,
        title = _a.title,
        label = _a.label;
    return React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "statusicon", className, CSSPrefix_1.prefixEnumClassNames(status)])
    }, React.createElement("div", null, React.createElement("svg", {
      focusable: "false",
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      viewBox: "0 0 24 24"
    }, React.createElement("title", null, title), React.createElement("circle", {
      cx: 12,
      cy: 11,
      r: 7
    }))), label && React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "statusicon-label"
    }, label));
  };

  StatusIcon.StatusType = StatusType;
  return StatusIcon;
}(React.Component);

exports.StatusIcon = StatusIcon;